import { Link } from '@remix-run/react';

import Text from '~/components/Text';
import type { NavigationLink } from '~/interfaces/publication';

interface Props {
  link: NavigationLink;
}

const SingleLink = ({ link }: Props) => {
  const isExternalLink = link.external_link;

  if (isExternalLink) {
    return (
      <a
        className="transition:all rounded-wt px-2 py-2 hover:bg-black/5"
        href={link.href}
        target="_blank"
        rel="nofollow noreferrer noopener"
      >
        <Text as="span" type="title" theme="navs" className="whitespace-nowrap text-xs sm:block">
          {link.cta_text}
        </Text>
      </a>
    );
  }

  return (
    <Link className="transition:all rounded-wt px-2 py-2 hover:bg-black/5" to={`/c/${link.href}`}>
      <Text as="span" type="title" theme="navs" className="hidden whitespace-nowrap text-xs sm:block">
        {link.cta_text}
      </Text>
    </Link>
  );
};

export default SingleLink;
